import { put, select } from 'redux-saga/effects';
import { selectSelectedLanguage } from '../userData/selectors';
import etrApi from '../utils/etrApi';
import { enqueueErrorSnackbar } from '../notifications/actionWrapper';
import { translate } from '../../utils/translation';
import { returnSnackbarMessage } from '../utils/utils';

export function fetchArchiveProjectsSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.post('/ppm/unit-projects/archive', payload);
      if (!data) throw new Error('No data');
      yield put(actions.fetchProjectsSuccess(data));
    } catch (error) {
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            error,
            translate('snackbarMessages.couldNotFetchProjects', lang),
          ),
        ),
      );
      yield put(actions.fetchProjectsError(error.message));
    }
  };
}

export function unArchiveProjectSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.put(
        '/ppm/unit-projects/archive?action=UNARCHIVE',
        payload,
      );
      yield put(actions.unArchiveProjectSuccess(data));
    } catch (error) {
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            error,
            translate('snackbarMessages.couldNotUnarchiveProject', lang),
          ),
        ),
      );
      yield put(actions.unArchiveProjectError(error.message));
    }
  };
}

export function deleteArchivedProjectSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      yield etrApi.delete(`/ppm/unit-project/${payload}`);

      yield put(actions.deleteProjectSuccess(payload));
    } catch (error) {
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            error,
            translate('snackbarMessages.couldNotDeleteProject', lang),
          ),
        ),
      );
      yield put(actions.deleteProjectError(error.message));
    }
  };
}
